<style lang="sass">
    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import block-newsletter
</style>

<script>
import { useEmitter } from '@nguyenshort/vue3-mitt'
import { ref, onMounted, nextTick  } from 'vue'
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { useStore } from 'vuex'

export default {
  setup(){
    const emitter = useEmitter()
    const store = useStore();
    const displayForm = ref(false);
    const formEl = ref(null);
    const { values, errors, defineField, validate } = useForm({
      validationSchema: yup.object({
        email: yup.string().email('L\'email est invalide').required('L\'email est requis'),
      }),
    });
    const [email, emailAttrs] = defineField('email', {
      validateOnModelUpdate: false,
    });

    async function send() {
      const uriPath = window.location.href;
      if (uriPath.includes("user_type")) {
        setTimeout(() => {
          emitter.emit('dispatchNewsletter', "gtm_user@gmail.com");
        }, 100);
      } else {
        if (!store.state.flag) {
          store.state.flag = true;
        } else {
          validate()
          .then((result) => {
            if (result.valid) {
              sendForm()
            }
        })
      }
      }
    }
    function updateInput(selector, value) {
        let input = formEl.value.querySelector(selector)
        if (input) {
            input.value = value
        }
    }
    function sendForm() {
        updateInput(`input[name='newsletter-email']`, email.value)
        emitter.emit('dispatchNewsletter', email.value)
    }

    onMounted(async () => {
      await nextTick()
      formEl.value = document.querySelector('.webform-submission-newsletter-form')
      displayForm.value = formEl.value.querySelector(".webform-confirmation") !== null
      send()
    })

    return {
      displayForm,
      send,
      email,
      errors,
      values,
      emailAttrs
    }
  }
}



</script>
